import { AfterViewChecked, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { WizardModalComponent } from '@app/shared/components';
import { MaintenancePlanDetailsFormComponent } from './forms/maintenance-plan-details-form/maintenance-plan-details-form.component';
import { MaintenancePlanToolsFormComponent } from './forms/maintenance-plan-tools-form/maintenance-plan-tools-form.component';
import {
    MaintenancePlanActivitiesFormComponent
} from './forms/maintenance-plan-activities-form/maintenance-plan-activities-form.component';
import { MaintenancePlanOverviewComponent } from '../maintenance-plan-overview/maintenance-plan-overview.component';

import * as _ from 'lodash'

enum PlanSteps {
    DETAILS = 0,
    TOOLS = 1,
    ACTIVITIES = 2,
    OVERVIEW = 3
}

@Component({
    selector: 'app-maintenance-plan-modal',
    templateUrl: './maintenance-plan-modal.component.html',
    styleUrls: ['./maintenance-plan-modal.component.scss']
})
export class MaintenancePlanModalComponent implements AfterViewChecked {
    @ViewChild(WizardModalComponent, {static: false}) modal: WizardModalComponent;
    @ViewChild(MaintenancePlanDetailsFormComponent, {static: false}) detailsForm: MaintenancePlanDetailsFormComponent;
    @ViewChild(MaintenancePlanToolsFormComponent, {static: false}) toolsForm: MaintenancePlanToolsFormComponent;
    @ViewChild(MaintenancePlanActivitiesFormComponent, {static: false}) activitiesForm: MaintenancePlanActivitiesFormComponent;
    @ViewChild(MaintenancePlanOverviewComponent, {static: false}) overview: MaintenancePlanOverviewComponent;

    @Input() isEdit = false;
    @Input() isDuplicate = false;
    @Input() isLoading = false;

    @Output() submit = new EventEmitter<any>();

    selectedStep = 0;
    plan: any = {};

    constructor(private cdr: ChangeDetectorRef) {
    }

    ngAfterViewChecked(): void {
        this.cdr.detectChanges();
    }

    open(plan: any = null) {
        if (plan) {
            this.plan = plan;
            setTimeout(() => this.detailsForm.init(plan));
        }
        this.modal.open();
        if (this.activitiesForm && !this.isEdit && !this.isDuplicate) {
            this.activitiesForm.init();
        }
    }

    onWizardSubmit() {
        if (!this.isEdit) {
            this.plan.version = 1;
        }
        this.submit.emit(this.plan);
        this.reset();
        this.modal.close();
    }

    reset() {
        this.selectedStep = 0;
        if (this.detailsForm) {
            this.detailsForm.reset();
        }

        if (this.toolsForm) {
            this.toolsForm.reset();
        }

        if (this.activitiesForm) {
            this.activitiesForm.reset();
        }
        this.plan = {};
        this.modal.reset();
    }

    onStepChange(stepIndex: number) {
        let formData = {};

        switch (this.selectedStep) {
            case PlanSteps.DETAILS:
                formData = this.detailsForm.getFormValue();
                break;
            case PlanSteps.TOOLS:
                formData = this.toolsForm.getFormValue()
                break;
            case PlanSteps.ACTIVITIES:
                formData = {
                    items: this.activitiesForm.getFormValue(),
                    activities: this.adaptActivities(this.activitiesForm.getFormValue())
                };
                break;
            case PlanSteps.OVERVIEW:
                break;
            default:
                break;
        }

        Object.assign(this.plan, formData);

        switch (stepIndex) {
            case PlanSteps.DETAILS:
                this.detailsForm.init(this.plan);
                break;
            case PlanSteps.TOOLS:
                this.toolsForm.init(this.plan.tools);
                break;
            case PlanSteps.ACTIVITIES:
                this.activitiesForm.init(this.plan);
                break;
            case PlanSteps.OVERVIEW:
                this.overview.init();
                break;
            default:
                break;
        }

        this.selectedStep = stepIndex;
    }

    onWizardCancel() {
        this.reset();
        this.modal.close();
    }

    get detailsFormValid() {
        return this.detailsForm ? this.detailsForm.valid : false;
    }

    get toolsFormValid() {
        if (this.isEdit && this.toolsForm) {
            return true;
        }
        return this.toolsForm ? this.toolsForm.valid : false;
    }

    get activitiesFormValid() {
        return this.activitiesForm ? this.activitiesForm.valid : false;
    }

    private adaptActivities(data: any) {
        const result = [];
        data.forEach(a => result.push({
            id: a.id,
            recurrences: a.selectedItems.map(item => {
                return {
                    id: item.id,
                    tasks: item.selectedTasks
                }
            })
        }));

        return result;
    }

}
